import { render } from "./UserName.vue?vue&type=template&id=28425bf7"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/common/user/UserName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28425bf7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28425bf7', __exports__)) {
    api.reload('28425bf7', __exports__)
  }
  
  module.hot.accept("./UserName.vue?vue&type=template&id=28425bf7", () => {
    api.rerender('28425bf7', render)
  })

}


export default __exports__